import config from './config.js'

export default {

  // Search parameter
  viewparams: {"start":0,"count":20,"value":"","filter":[],"sort":"map_id","sdir":"asc"},

  // list current article selection
  list: function(ctrl,cb_success) {
    console.log('list articles');
    var u = config.baseUrl + 'rest/search/?start=' + this.viewparams.start + '&count=' + this.viewparams.count;
    if (this.viewparams.value.length > 0) {
      u += '&value=' + encodeURIComponent(this.viewparams.value);
    }
    if (this.viewparams.filter.length > 0) {
      u += '&filter=' + encodeURIComponent(JSON.stringify(this.viewparams.filter));
    }
    u += '&sort=' + encodeURIComponent(this.viewparams.sort) + '&dir=' + encodeURIComponent(this.viewparams.sdir);

    config.get(ctrl,u,'Artikelliste laden',cb_success);
  },

  // load article reorder dates
  reorders: function(id,ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/data/reorders/' + encodeURIComponent(id),'Nachliefertermine laden',cb_success);
  },

  // load article info link list
  infolinks: function(id,ctrl,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/data/products/'  + encodeURIComponent(id) + '/infos','Artikel Info Links laden',cb_success);
  },

  // load cat tree normal
  cattree: function(cb_success) {
    return fetch(config.baseUrl + 'rest/data/categories/tree?lang=de',{
      credentials: 'include',
    }).then( resp => resp.json()).then(cb_success);
  },

  // load single article
  load: function(id,cb_success) {
    var u = config.baseUrl + 'rest/data/products/' + encodeURIComponent(id);
    fetch(u,{credentials: 'include'}).then(resp => resp.json()).then(cb_success);
  },

  loadtext: function(id,cb_success) {
    var u = config.baseUrl + 'rest/data/products/' + encodeURIComponent(id) + '/descs';
    fetch(u,{credentials: 'include'}).then(resp => resp.json()).then(cb_success);
  },

  prices: function(id,cb_success) {
    var u = config.baseUrl + 'rest/data/products/' + encodeURIComponent(id) + '/price';
    fetch(u,{credentials: 'include'}).then(resp => resp.json()).then(cb_success);
  },

  searchSelections: function(ctrl,start,count,search,cb) {
    var url = config.baseUrl + 'rest/data/articleselections?start=' + start + '&count=' + count;
    if (search && search.length > 0) {
      url += '&search=' + encodeURIComponent(search);
    }
    config.get(ctrl,url,'Artikelsortimente laden',cb);
  }
}
